import React from "react";

/**
 * Friendly, reassuring error state for a feature whose data failed to load.
 * Shown instead of a blank page, an endless spinner, or a misleading
 * "nothing here yet" message when the server is just slow or waking up.
 */
export default function FeatureError({
  onRetry,
  title = "We're having trouble reaching the family server",
  message = "It may be waking up — this usually clears in a few seconds. Your information is safe.",
}) {
  return (
    <div className="flex items-center justify-center min-h-[300px] p-6">
      <div className="max-w-[420px] text-center rounded-2xl border border-dupontCreamDk/60 dark:border-darkGold/10 bg-white dark:bg-darkCard shadow-md px-7 py-8">
        <div className="text-[44px] mb-2">🌿</div>
        <h3 className="font-display text-[20px] font-bold text-dupontBlue dark:text-darkText mb-2">
          {title}
        </h3>
        <p className="text-[15px] font-body text-dupontGray dark:text-darkTextSecondary leading-relaxed mb-5">
          {message}
        </p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="px-6 py-2.5 bg-dupontBlue text-white rounded-full text-[15px] font-medium hover:bg-dupontBlue/90 transition-colors"
          >
            Try again
          </button>
        )}
      </div>
    </div>
  );
}
